import { DashboardControlsProvider } from 'contexts/Dashboard/useDashboardControls';
import {
  DefaultGreenPlatesWidgets,
  GreenPlatesWidgetsEnum,
} from './GreenPlatesDashboard/utils';
import ViewActionsBar from 'components/Dashboard/ViewActionsBar';
import GreenPlatesDashboard from './GreenPlatesDashboard';
import GreenPlatesFilterBar from './GreenPlatesDashboard/GreenPlatesFilterBar';

const GreenPlatesPage = () => {
  return (
    <DashboardControlsProvider<GreenPlatesWidgetsEnum>
      storageKey="GreenPlatesDashboard"
      defaultWidgets={DefaultGreenPlatesWidgets}
    >
      <GreenPlatesFilterBar />
      <ViewActionsBar />
      <GreenPlatesDashboard />
    </DashboardControlsProvider>
  );
};

export default GreenPlatesPage;
